import environment from "./BaseEnvironment";

const baseUrl = "https://test.epona.upquai.com/";
const baseApi = "https://test.webservice.epona.upquai.com/api";
const APP_ENVIRONMENT = "eponaTesting"
const enableItemClassification = true;


const env = environment(baseApi);

const TestEnvironment = {
  ...env,
  baseUrl: baseUrl,
  baseApi: baseApi,
  APP_ENVIRONMENT : APP_ENVIRONMENT,
  enableItemClassification: enableItemClassification,
  // Keep OFF: Item Price is usually already the extended line amount (Betrag).
  // price × qty double-counts. VAT breakdown is shown independently of this flag.
  enableQuantityTotals: false

};

export default TestEnvironment;
